import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { currencyFormat } from 'utils/currencyFormat';
import { showModal } from 'actions';

import localize from 'components/Localize/Localize';
import styles from './PayBrightLink.css';
import translations from './translations';

class PayBrightLink extends React.Component {
  getMonthlyPayment() {
    const monthlyPayment = this.props.price / 6;

    return currencyFormat(monthlyPayment, `en-CA`, false);
  }

  render() {
    return (
      <div className={styles[`container`]}>
        <button
          className={styles[`link`]}
          onClick={this.props.showModal.bind(this, `paybright`)}
        >
          {`${this.props.t.financingWith1} ${this.getMonthlyPayment()}${this.props.t.financingWith2}`}
          <img
            alt={this.props.t.imageDescription}
            className={styles[`logo`]}
            src="/assets-spa/images/paybright.svg"
          />
        </button>
      </div>
    );
  }
}

PayBrightLink.propTypes = {
  price: PropTypes.number.isRequired,
  showModal: PropTypes.func.isRequired,
  t: PropTypes.shape({
    financingWith1: PropTypes.string.isRequired,
    financingWith2: PropTypes.string.isRequired,
    imageDescription: PropTypes.string.isRequired,
  }).isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  showModal: (key) => {
    dispatch(showModal(key));
  },
});

export default connect(null, mapDispatchToProps)(localize(PayBrightLink, translations));
